var CellView = require('./cell-view')

module.exports = CellView.extend({
    template: Ember.Handlebars.compile(''),

    extraClass: 'actions-placeholder'
})
